import React from 'react';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const AnalyticsDataSkeleton = () => (
  <>
    <div style={{ marginLeft: '12px' }}>
      <Skeleton borderRadius="1rem" height="35px" width="20rem" margin="0" />
    </div>

    <div className="grid-container">
      <div id="grid_items_1">
        <div className=" card_height" />
        {[...Array(4)].map((e, i) => (
          <div className=" card_height" key={i}>
            <Skeleton borderRadius="1rem" height="75px" width="100%" margin="0" />
          </div>
        ))}
      </div>
      <div id="grid_items_2">
        <div className=" card_height" />

        {[...Array(4)].map((e, i) => (
          <div className=" card_height" key={i}>
            <Skeleton borderRadius="1rem" height="75px" width="100%" margin="0" />
          </div>
        ))}
      </div>

      <div id="grid_items_3">
        {[...Array(4)].map((e, i) => (
          <div className=" card_height" key={i}>
            <Skeleton borderRadius="1rem" height="75px" width="100%" margin="0" />
          </div>
        ))}
      </div>

      <div id="grid_items_4">
        <div className=" card_height" />

        {[...Array(4)].map((e, i) => (
          <div className=" card_height" key={i}>
            <Skeleton borderRadius="1rem" height="75px" width="100%" margin="0" />
          </div>
        ))}
      </div>
    </div>
  </>

);
export default AnalyticsDataSkeleton;
